module.exports = __webpack_public_path__ + "static/media/arrowSide.e2c0fc67.svg";